import { render, staticRenderFns } from "./clientOrderTable.vue?vue&type=template&id=34fbf65d&scoped=true"
import script from "./clientOrderTable.vue?vue&type=script&lang=js"
export * from "./clientOrderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fbf65d",
  null
  
)

export default component.exports